export class Sc3FailedTransactionMessageLoad {
  public static readonly type = '[Sc3FailedTransactionMessage] Load';
  constructor(public payload: string) {}
}

export class Sc3FailedTransactionMessageInitialState {
  public static readonly type = '[Sc3FailedTransactionMessage] Set initial state';
}
